<table *ngIf="lastUpdatedBy || lastUpdatedDate">
    <tr>
        <td>Last Updated By:</td>
        <th>{{ lastUpdatedBy }}</th>
    </tr>
    <tr>
        <td>Last Updated Date:</td>
        <th>{{ lastUpdatedDate | date: dateTimeFormat }}</th>
    </tr>
</table>
